export const TIPOS_VEICULO_OPCOES = Object.freeze([
  { id: 1, nome: "Carro" },
  { id: 2, nome: "Moto" },
]);

export const TIPOS_VEICULO_LABEL = Object.freeze({
  1: "Carro",
  2: "Moto",
});

export function labelTipoVeiculo(id) {
  if (id == null || id === "") return "";
  return TIPOS_VEICULO_LABEL[id] || "";
}
